import { createDrawerStore } from '../drawer/createDrawerStore';

export const useInvoiceDrawerStore = createDrawerStore();
